export const ExternalLinkStyles = {
    link: {
        textDecoration: 'underline',
    },
    icon: {
        marginTop: 'auto',
        marginBottom: 'auto',
        marginLeft: 1,
    },
}
